import { IMenuItem } from '@/types/menu';
import { ButtonBase, Box } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import React, { FC } from 'react';
import { getImage, ImageSize } from '@shared/utils/imageFormat';

interface IProps {
  data: IMenuItem;
  conferenceId: string;
  leftMenu?: boolean;
}

const useStyles = (theme: Theme) => ({
  root: {
    padding: '6px 0px !important',
    fontWeight: `${theme.typography.fontWeightBold} !important`,
    margin: '3px 8px !important',
  },
  leftMenu: {
    padding: '2px 0 !important',
    margin: '0 !important',
  },
  elevated: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    borderRadius: '20px !important',
    padding: '6px 17px !important',
  },
  img: {
    maxHeight: '70px !important',
    maxWidth: '100% !important',
  },
});

/**
 *
 * Renders an item for the top menu
 *
 * @params data required any
 * @returns JSX.Element
 * @example
 * <TopMenuItem data={menuData} />
 */
export const TopMenuItem: FC<IProps> = ({
  data: { title, type, url, target, picture, icon, design },
  conferenceId,
  leftMenu = false,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <ButtonBase
      sx={{
        ...classes.root,
        ...(design === 'elevated' && classes.elevated),
        ...(leftMenu && classes.leftMenu),
      }}
      href={url}
      target={target || null}
    >
      {picture ? (
        <Box
          component="img"
          sx={classes.img}
          src={getImage(picture, ImageSize.Small, conferenceId)}
          alt={title}
        />
      ) : (
        title
      )}
    </ButtonBase>
  );
};
